/**
 * TPO recap earnings client (DEV-3636, SkynetAPI behind the admin/skynet gateway).
 * GET /api/command-center/earnings aggregates funded loans for the authenticated
 * company into a historical compensation record (owner-only claim). Renamed from
 * the legacy /api/tpoRecap/earnings path under the BrokerHome -> CommandCenter
 * rename (DEV-4041).
 *
 * LEGAL GATE (RESPA §8 / Reg Z 1026.36(d)): historical record only — every figure
 * is framed with its as-of date and rolling window. No forward projection. Returns
 * 403 until the tpoRecap.viewEarnings owner claim is seeded + deployed; callers
 * must degrade gracefully (skipResponseInterceptor forbiddenError).
 *
 * Response shape:
 *   { compPaidYtdUsd, priorYtdCompUsd, fundedCount, priorYtdFundedCount,
 *     fundedVolumeUsd, periodStart, periodEnd, priorPeriodStart, priorPeriodEnd,
 *     asOfDate, entityName, compPlan }
 */
export class TpoRecapEarningsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getEarnings({ asOfDate, config = {} } = {}) {
    return this.#http.get('/api/command-center/earnings', { ...config, params: { asOfDate } });
  }
}
